<div ng-controller="registerGeneralController as regGeneralCtrl" ng-class="{'modal-view': regGeneralCtrl.isModal()}">
    <c-auto-form config="regGeneralCtrl.autoFormConfig"></c-auto-form>
</div>